var exports = {
  "CR": "MessageReactionsModal.module__modalRoot___b092eE" + " " + __webpack_require__(545076)["root"] + " " + __webpack_require__(545076)["default"],
  "jE": "MessageReactionsModal.module__modalContent___b092eE",
  "Ij": "MessageReactionsModal.module__modalLayout___b092eE",
  "pz": "MessageReactionsModal.module__sidebar___b092eE",
  "PC": "MessageReactionsModal.module__reactionFiltersPane___b092eE",
  "VG": "MessageReactionsModal.module__reactionListContainer___b092eE",
  "Kv": "MessageReactionsModal.module__moveShortcut___b092eE",
};

module.exports = exports;
